module.exports = __webpack_public_path__ + "img/bitbucket.6cbe8f7f.svg";